import React from 'react';

export default function CustomerSnapshot({ job }) {
  return (
    <div>
      <h3 style={{
        fontSize: '16px',
        fontWeight: '600',
        color: 'var(--text-primary)',
        marginBottom: '16px'
      }}>
        Customer Information
      </h3>

      <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '12px'
      }}>
        {/* Customer Name */}
        <div style={{
          display: 'flex',
          gap: '8px',
          alignItems: 'flex-start'
        }}>
          <span style={{
            fontSize: '13px',
            color: 'var(--text-secondary)',
            minWidth: '80px',
            fontWeight: '600'
          }}>
            Name:
          </span>
          <span style={{
            fontSize: '14px',
            color: 'var(--text-primary)',
            fontWeight: '600'
          }}>
            {job.customerName || 'Not provided'}
          </span>
        </div>

        {/* Phone */}
        {job.phoneNumber && (
          <div style={{
            display: 'flex',
            gap: '8px',
            alignItems: 'flex-start'
          }}>
            <span style={{
              fontSize: '13px',
              color: 'var(--text-secondary)',
              minWidth: '80px',
              fontWeight: '600'
            }}>
              Phone:
            </span>
            <span
              onClick={() => window.location.href = `tel:${job.phoneNumber}`}
              style={{
                fontSize: '14px',
                color: 'var(--brand-brown)',
                cursor: 'pointer',
                textDecoration: 'underline'
              }}
            >
              {job.phoneNumber}
            </span>
          </div>
        )}

        {/* Email */}
        {job.customerEmail && (
          <div style={{
            display: 'flex',
            gap: '8px',
            alignItems: 'flex-start'
          }}>
            <span style={{
              fontSize: '13px',
              color: 'var(--text-secondary)',
              minWidth: '80px',
              fontWeight: '600'
            }}>
              Email:
            </span>
            <span
              onClick={() => window.location.href = `mailto:${job.customerEmail}`}
              style={{
                fontSize: '14px',
                color: 'var(--brand-brown)',
                cursor: 'pointer',
                textDecoration: 'underline'
              }}
            >
              {job.customerEmail}
            </span>
          </div>
        )}

        {/* Address */}
        {job.address && (
          <div style={{
            display: 'flex',
            gap: '8px',
            alignItems: 'flex-start'
          }}>
            <span style={{
              fontSize: '13px',
              color: 'var(--text-secondary)',
              minWidth: '80px',
              fontWeight: '600'
            }}>
              Address:
            </span>
            <span style={{
              fontSize: '14px',
              color: 'var(--text-primary)'
            }}>
              {job.address}
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
